export default __webpack_public_path__ + "static/media/DSC_8.577fb7d7.jpg";